module.exports = __webpack_public_path__ + "img/europe_1.e6cfd7d.png";